if (!customElements.get('blh-collection-gallery')) {
  class BLHCollectionGallery extends HTMLElement {
    connectedCallback() {
      this.links = [...this.querySelectorAll('.blh-collection-gallery__open')];
      this.dialog = this.querySelector('dialog');
      if (!this.links.length || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.image = this.querySelector('.blh-collection-gallery__full');
      this.caption = this.querySelector('.blh-collection-gallery__caption');
      this.position = this.querySelector('.blh-collection-gallery__position');
      this.original = this.querySelector('.blh-collection-gallery__original');
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const link = event.target.closest('.blh-collection-gallery__open');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const index = this.links.indexOf(link);
        if (index < 0) return;
        event.preventDefault();
        this.opener = link;
        this.show(index);
        this.dialog.showModal();
      }, options);
      this.querySelector('.blh-collection-gallery__close').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('.blh-collection-gallery__previous').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('.blh-collection-gallery__next').addEventListener('click', () => this.show(this.index + 1), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);
      this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
    }
    show(index) {
      this.index = (index + this.links.length) % this.links.length;
      const link = this.links[this.index];
      this.image.alt = link.dataset.caption;
      this.image.src = link.href;
      this.caption.textContent = link.dataset.caption;
      this.position.textContent = `${this.index + 1} / ${this.links.length}`;
      this.original.href = link.href;
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.abort?.abort();
    }
  }
  customElements.define('blh-collection-gallery', BLHCollectionGallery);
}
